import { useQuery } from '@tanstack/react-query';
import { mockDelay } from '@/shared/api/mockDelay';
import { accessMatrix, auditLog } from './mockData';
import { getExtraAuditEntries } from '@/shared/api/auditStorage';

function mergeAuditLog() {
  return [...getExtraAuditEntries(), ...auditLog];
}

/** GET /api/admin/access-matrix */
export function useAccessMatrix() {
  return useQuery({
    queryKey: ['admin', 'accessMatrix'],
    queryFn: () => mockDelay(accessMatrix),
  });
}

/** GET /api/admin/audit-log */
export function useAuditLog() {
  return useQuery({
    queryKey: ['admin', 'auditLog'],
    queryFn: () => mockDelay(mergeAuditLog()),
  });
}
